import React from 'react';
import { Users, Globe, Calendar, Briefcase, TrendingUp, Award } from 'lucide-react';

const HDataStats = () => {
  return (
    <div className="bg-gray-50 min-h-screen p-4 md:p-10 font-sans text-slate-800">
      <div className="max-w-6xl mx-auto">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-8 gap-6">
          <div className="max-w-md">
            <p className="text-gray-500 text-sm mb-2">The Reasons Why HData Stand Out</p>
            <h1 className="text-3xl md:text-4xl font-bold leading-tight">
              HData Unfolds Solutions To Everything
            </h1>
            <div className="h-1 w-20 bg-purple-600 mt-4"></div>
          </div>
          
          {/* Awards Badges */}
          <div className="flex gap-4 grayscale opacity-70">
            <div className="border p-2 rounded flex flex-col items-center justify-center w-20 h-20 text-[10px] text-center font-bold">
              <Award size={20} />
              TOP SOFTWARE DEVELOPERS
            </div>
            <div className="border p-2 rounded flex flex-col items-center justify-center w-20 h-20 text-[10px] text-center font-bold">
              <Briefcase size={20} />
              RELIABLE APP COMPANY 2022
            </div>
            <div className="border p-2 rounded flex flex-col items-center justify-center w-20 h-20 text-[10px] text-center font-bold">
              <TrendingUp size={20} />
              BIG DATA ANALYTICS 2022
            </div>
          </div>
        </div>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-12 gap-0 border rounded-[2.5rem] overflow-hidden bg-white shadow-sm">
          
          {/* Row 1 */}
          <div className="lg:col-span-2 border-b border-r p-8 flex flex-col justify-center relative overflow-hidden group">
            <span className="text-4xl font-bold">10+</span>
            <p className="text-gray-600 mt-2">Years Of Experience</p>
            <Calendar className="absolute -bottom-2 -right-2 text-gray-100 group-hover:text-gray-200 transition-colors" size={80} />
          </div>

          <div className="lg:col-span-2 border-b border-r p-8 flex flex-col justify-center relative overflow-hidden group">
            <span className="text-4xl font-bold">100+</span>
            <p className="text-gray-600 mt-2">Clients</p>
            <Users className="absolute -bottom-2 -right-2 text-gray-100 group-hover:text-gray-200 transition-colors" size={80} />
          </div>

          <div className="lg:col-span-4 border-b border-r p-8 flex flex-col justify-center relative overflow-hidden group">
            <span className="text-4xl font-bold">97%</span>
            <p className="text-gray-600 mt-2">Client Retention Rate</p>
            <TrendingUp className="absolute bottom-2 right-4 text-gray-100 group-hover:text-gray-200 transition-colors" size={100} />
          </div>

          {/* Right Purple Feature (Spans 2 rows) */}
          <div className="lg:col-span-4 lg:row-span-3 bg-purple-700 p-10 text-white flex flex-col justify-center items-center relative overflow-hidden">
            <div className="z-10 text-center">
              <p className="text-lg mb-4">Powered By</p>
              <div className="flex items-center justify-center gap-2">
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                  <div className="w-6 h-6 bg-purple-700 rounded-sm rotate-45"></div>
                </div>
                <span className="text-2xl font-bold tracking-tight">Hyperlink InfoSystem</span>
              </div>
            </div>
            {/* Background Overlay Image Mockup */}
            <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80')] bg-cover"></div>
          </div>

          {/* Row 2 */}
          <div className="lg:col-span-4 border-b border-r bg-purple-600 text-white p-8 flex items-center justify-between relative overflow-hidden">
             <div>
                <span className="text-4xl font-bold">40+</span>
                <p className="mt-2 opacity-90">AI Solutions</p>
             </div>
             <div className="w-24 h-24 bg-gradient-to-br from-blue-400 to-purple-400 rounded-full blur-2xl opacity-50 absolute right-4"></div>
             <img src="https://cdn-icons-png.flaticon.com/512/2103/2103633.png" className="w-24 z-10 brightness-110" alt="AI Icon" />
          </div>

          <div className="lg:col-span-2 border-b border-r p-8 flex flex-col justify-center relative overflow-hidden group">
            <span className="text-4xl font-bold">350+</span>
            <p className="text-gray-600 mt-2">Employees</p>
            <Users className="absolute -bottom-2 -right-2 text-gray-100" size={60} />
          </div>

          <div className="lg:col-span-2 border-b border-r p-8 flex flex-col justify-center relative overflow-hidden group">
            <span className="text-4xl font-bold">20+</span>
            <p className="text-gray-600 mt-2">Countries</p>
            <Globe className="absolute -bottom-2 -right-2 text-gray-100" size={60} />
          </div>

          {/* Row 3 */}
          <div className="lg:col-span-4 border-r p-8 relative overflow-hidden flex flex-col justify-center">
            <span className="text-4xl font-bold">80+</span>
            <p className="text-gray-600 mt-2">Big Data Solutions</p>
            <span className="absolute bottom-2 right-4 text-6xl font-black text-gray-50 select-none uppercase tracking-tighter">Big Data</span>
          </div>

          <div className="lg:col-span-4 p-8 flex flex-col justify-center relative">
            <p className="text-sm text-gray-400 mb-1">Awarded As</p>
            <h3 className="text-xl font-bold max-w-[200px]">Top Big Data Analytics & BI Consultant</h3>
            <div className="absolute right-8 bottom-8 opacity-10 font-black italic text-4xl">Clutch</div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HDataStats;